import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { useBreakpoint } from '@hivebrite/design-system/Theme';

import PreviewModal from 'hb-react/shared/components/DesignSystem/Modal/PreviewModal';

import Desktop from './Responsive/Desktop';
import Mobile from './Responsive/Mobile';

export const FilePreview = (props) => {
  const breakpoint = useBreakpoint();

  const isSmallOrMediumScreen = useMemo(
    () => ['s', 'm'].includes(breakpoint),
    [breakpoint],
  );

  const Component = isSmallOrMediumScreen ? Mobile : Desktop;

  return <Component {...props} />;
};

const FilePreviewModal = ({
  isOpen,
  onCloseModal,
  screenReadersCloseButtonText,
  withFullScreenModal = undefined,
  overwritingStyles = {},
  ...rest
}) => (
  <PreviewModal
    isOpen={isOpen}
    onCloseModal={onCloseModal}
    screenReadersCloseButtonText={screenReadersCloseButtonText}
    withFullScreenModal={withFullScreenModal}
    overwritingStyles={overwritingStyles}
  >
    <FilePreview {...rest} />
  </PreviewModal>
);

FilePreviewModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired,
  screenReadersCloseButtonText: PropTypes.string.isRequired,
};

export default FilePreviewModal;
